// extracted by mini-css-extract-plugin
export default {"iconWithDot":"Menu_iconWithDot__Al3FD","iconDot":"Menu_iconDot__yGakM"};